import appStateActions from '../../actions/appState/appState';

const initialState = {
  isAppInitialized: false,
};

const appStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case appStateActions.INIT_APP:
      return {
        ...state,
        isAppInitialized: true,
      };
    case appStateActions.SET_IS_ONLINE:
      return {
        ...state,
        isOnline: action.isOnline,
      };
    default:
      return state;
  }
};

export default appStateReducer;
